// A settled freebet bet (History tab). Pure render — every value is pre-derived
// in the bets mapper. Columns: Date(date/time) | Source | Id | Stake | Win.
const FreebetHistoryCard = ({ data }) => (
  <div className="standard-normal-bet-card-outer-container">
    <div className="standard-normal-bet-card-inner-container">
      <div className="standard-normal-bet-card-element">
        <div className="standard-normal-bet-card-element-date">{data?.date}</div>
        <div className="standard-normal-bet-card-element-time">{data?.time}</div>
      </div>
      <div className="standard-normal-bet-card-element">
        <div className="standard-normal-bet-card-element-subType">{data?.sourceText}</div>
      </div>
      <div className="standard-normal-bet-card-element">
        <div className="standard-normal-bet-card-element-subType" title={data?.tag}>
          {data?.tagShort}
        </div>
      </div>
      <div className="standard-normal-bet-card-element">
        <div className="standard-normal-bet-card-element-stake">{data?.stake}</div>
      </div>
      <div className="standard-normal-bet-card-element">
        <div className={`standard-normal-bet-card-element-payout ${data?.won ? 'won' : 'lost'}`}>
          {data?.payout}
        </div>
      </div>
    </div>
  </div>
)

export default FreebetHistoryCard
